import request from "@/utils/requestJSON";

export function getHomeIndex() {
  return request({
    url: "/storage/Home/index.json",
    method: "get",
  });
}
